export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mask_top_left.b837757.svg";